/** Minha conta — troca da própria senha e ativação voluntária de MFA (doc 19 §1: MFA disponível a todos os perfis). */
import { useState } from 'react';
import { api, ErroApi } from '../api.ts';
import { useSessao } from '../sessao.tsx';
import { Aviso, Campo, Selo } from '../componentes/basicos.tsx';
import { agruparSegredo } from '../formatos.ts';

export function TelaMinhaConta() {
  const { eu, recarregar } = useSessao();
  const [msg, setMsg] = useState<{ tipo: 'erro' | 'sucesso'; texto: string } | null>(null);
  const [cadastro, setCadastro] = useState<{ segredo: string; otpauth_url: string } | null>(null);

  const falhar = (e: unknown) => setMsg({ tipo: 'erro', texto: (e as ErroApi).message });

  return (
    <section className="cartoes">
      {msg && <Aviso tipo={msg.tipo}>{msg.texto}</Aviso>}
      <div className="cartao">
        <h3>Dados de acesso</h3>
        <p>
          <strong>{eu?.nome}</strong> · {eu?.email} · <Selo tom="destaque">{eu?.perfil_nome}</Selo>
        </p>
      </div>

      <div className="cartao">
        <h3>Verificação em duas etapas (MFA)</h3>
        {eu?.mfa_habilitado ? (
          <p>
            <Selo tom="ativo">Habilitado</Selo> Seu login exige o código do aplicativo autenticador. Em caso de perda do dispositivo, peça ao
            Administrador a redefinição do MFA.
          </p>
        ) : cadastro ? (
          <form
            onSubmit={async (e) => {
              e.preventDefault();
              try {
                await api.post('/api/auth/mfa/ativar', { codigo: String(new FormData(e.currentTarget).get('codigo')).replace(/\s/g, '') });
                setCadastro(null);
                setMsg({ tipo: 'sucesso', texto: 'MFA habilitado com sucesso.' });
                await recarregar();
              } catch (err) {
                falhar(err);
              }
            }}
          >
            <p>Adicione a chave abaixo no seu aplicativo autenticador e informe o código gerado.</p>
            <div className="segredo">{agruparSegredo(cadastro.segredo)}</div>
            <p className="ajuda">
              No celular: <a className="link" href={cadastro.otpauth_url}>abrir no aplicativo autenticador</a>.
            </p>
            <Campo rotulo="Código de verificação">{(id) => <input id={id} name="codigo" inputMode="numeric" autoComplete="one-time-code" required maxLength={7} />}</Campo>
            <button className="botao-primario" type="submit">
              Ativar MFA
            </button>
          </form>
        ) : (
          <>
            <p>Recomendado para todos os perfis (obrigatório para Administrador e Financeiro).</p>
            <button className="botao-primario" onClick={() => api.post('/api/auth/mfa/iniciar').then(setCadastro).catch(falhar)}>
              Configurar MFA
            </button>
          </>
        )}
      </div>

      <div className="cartao">
        <h3>Alterar senha</h3>
        <form
          onSubmit={async (e) => {
            e.preventDefault();
            const form = e.currentTarget;
            const f = new FormData(form);
            if (f.get('nova_senha') !== f.get('confirmacao')) {
              setMsg({ tipo: 'erro', texto: 'A confirmação não confere com a nova senha.' });
              return;
            }
            try {
              await api.post('/api/auth/alterar-senha', { senha_atual: f.get('senha_atual'), nova_senha: f.get('nova_senha') });
              form.reset();
              setMsg({ tipo: 'sucesso', texto: 'Senha alterada. Outras sessões abertas foram encerradas.' });
            } catch (err) {
              falhar(err);
            }
          }}
        >
          <Campo rotulo="Senha atual">{(id) => <input id={id} name="senha_atual" type="password" autoComplete="current-password" required />}</Campo>
          <Campo rotulo="Nova senha" ajuda="Mínimo de 12 caracteres.">{(id) => <input id={id} name="nova_senha" type="password" autoComplete="new-password" required minLength={12} />}</Campo>
          <Campo rotulo="Confirmar nova senha">{(id) => <input id={id} name="confirmacao" type="password" autoComplete="new-password" required minLength={12} />}</Campo>
          <button className="botao-primario" type="submit">
            Alterar senha
          </button>
        </form>
      </div>
    </section>
  );
}
